export {
  default,
  ICON_KEYS,
  ICON_REGISTRY,
} from '@/shared/components/ModelIcon';
export type { ModelIconProps } from '@/shared/components/ModelIcon';
